import {
    agencyActions,
    agencyThunks as defaultThunks,
    agencySelectors as defaultSelectors,
    agencyReducer,
} from './Agency-slice';
import * as thunks from './Agency-thunks';
import * as selectors from './Agency-selectors';

const agencyThunks = { ...defaultThunks, ...thunks };
const agencySelectors = { ...defaultSelectors, ...selectors };

export { agencySelectors, agencyActions, agencyThunks, agencyReducer };
